import axios from 'axios'
import React, { useEffect, useState } from 'react'
import { Col, Container, Row } from 'react-bootstrap'
import { Link } from 'react-router-dom'

const Footer = () => {
  const [page, setPages] = useState([]);

  useEffect(() =>{
    pages();
  },[])


  const pages = async () =>{
    try {
      // setLoading(true)
      let formData = new FormData();
      formData.append('data[salt]', process.env.REACT_APP_API_SALT);
      formData.append('data[sign]', process.env.REACT_APP_API_SIGN);
      formData.append('data[user_id]', localStorage.getItem('user_id') != null ? localStorage.getItem('user_id') : 271);
      axios.get(`${process.env.REACT_APP_API_URL}/pages`, formData).then((response) => {
        // setLoading(false)
        console.log(response.data);
        setPages(response.data.data)
      })
      
    } catch (error) {
      console.log(error);
      
    }
  }


  return (
    <>
    <Container className='mt-1 mb-5 footer'>
      <Row>
        <Col md={12} sm={12} xs={12}>
        <hr style={{
          border:"1px solid white",
        }} />
        </Col>
        <Row>
      {page.map((item, index) => (
            <Col md={6} sm={6} xs={6} key={index}>
                <Link to={`/page/${item.page_slug}`}>{item.page_title}</Link>
            </Col>
        ))}



          </Row>
        
      {/*   <Col md={6} sm={6} xs={6}>
        <Row>
          <Col sm={12} md={12} xs={12}><Link to="https://api.navrangott.com/page/about-us">About Us</Link></Col>
          <Col sm={12} md={12} xs={12}><Link to="https://api.navrangott.com/page/terms-and-conditions">Terms & Conditions</Link></Col>
          <Col sm={12} md={12} xs={12}><Link to="https://api.navrangott.com/page/privacy-policy">Privacy Policy</Link></Col>
          <Col sm={12} md={12} xs={12}><Link to="https://api.navrangott.com/page/contact-us">Contact Us</Link></Col>
        </Row>
       
        </Col>

        <Col md={6} sm={6} xs={6}>
        <Row>
          <Col sm={12} md={12} xs={12}><Link to="https://api.navrangott.com/page/refund-policy">Refund Policy</Link></Col>
          <Col sm={12} md={12} xs={12}><Link to="https://api.navrangott.com/page/grieviance-policy">Grievance Policy</Link></Col>
          
        </Row>
       
        </Col> */}

      </Row>
    </Container>
    </>
  )
}

export default Footer